import type { AgentManifest } from '@indipia/shared';
import { routes, shareRoutes } from './src/routes';

// 나의 현장 작업공간(셸 SiteWorkspaceDrawer)의 '공사현황' 탭에 마운트하는 단일 현장 피드(REQ-11-07).
export { SiteWorkFeed, type SiteWorkFeedProps } from './src/components/SiteWorkFeed';

export const manifest: AgentManifest = {
  agentId: 'work-log',
  routes,
  shareRoutes,
  menuItems: [
    {
      id: 'work-log',
      label: '인디공사현황',
      icon: 'book-open',
      path: '/agents/work-log',
      category: 'professional',
      order: 70,
    },
  ],
  permissions: ['OWNER', 'STAFF'],
};
